module.exports = __webpack_public_path__ + "img/QUEL_concentration_V2_top_sm.97b8452b.webp";